<template>
  <div class="m-0 dbozone-font bg-punkstar" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-punkstar" style="margin-bottom:1rem;">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang}`"
          >
            {{ $t("punkstar.paytable.symtable_title") }}
          </h5>
        </section>
      </div>
      <div class="d-flex flex-column nav-special-symbols mb-5" >
        <div class="col-12 justify-content-center d-flex flex-row pading4 ">
          <div class="col-3 align-items-center d-flex pading4">
            <img class="" :src="require(`../../assets/resultGame/punkstar/wild_full.png`)" alt="" style="width:100%"/>
          </div>
            <div class="col-3 align-items-center d-flex pading4">
              <span class=" text-sub" :class="`-${lang}`" style="line-height: 1;">
                  {{ "5 - " + paytable[9][4] }}
            <br />{{ "4 - " + paytable[9][3] }}
            <br />{{ "3 - " + paytable[9][2] }}
            <br />{{ "2 - " + paytable[9][1] }}
          </span>
            </div>
          <div class="col-6 align-items-center d-flex pading4">
            <p class="font-weight-bold text-sub justify-content-center mt-2" :class="`-${lang} -special`" style="line-height: 1;" >
              {{ $t("punkstar.paytable.symtable_wild") }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column nav-special-symbols" >

        <div class="col-12 justify-content-center d-flex flex-row pading4">
          <div class="col-3 align-items-center d-flex pading4" >
            <img class="" :src="require(`../../assets/resultGame/punkstar/symbol_11.png`)" alt="" style="width:100%;"/>
          </div>
          <div class="col-9 align-items-center d-flex pading4">
            <p class="font-weight-bold text-sub  symbol-line-height" :class="`-${lang} -special`" style="margin:0px" >
              {{ $t("punkstar.paytable.symtable_bonus") }}
              <br/>
              <u> {{ $t("punkstar.paytable.symtable_bonus2") }}</u> <b> <span style="font-size: larger;color: gold"> X525</span> </b>
            </p>
           
          </div>
        </div>
        <div class="col-12 justify-content-center d-flex flex-row pading4">
          <div class="col-3 align-items-center d-flex pading4">
            <img class="" :src="require(`../../assets/resultGame/punkstar/symbol_10.png`)" alt=""  style="width:100%" />
          </div>
          <div class="col-3 align-items-center d-flex pading4">
             <span class=" text-sub" :class="`-${lang}`" style="line-height: 1;">
                  {{ "5 - " + paytable[10][4]}}
            <br />{{ "4 - " + paytable[10][3]}}
            <br />{{ "3 - " + paytable[10][2]}}
          </span>
           </div>
           <div class="col-6 align-items-center d-flex pading4">
             <span class=" text-sub" :class="`-${lang}`" style="line-height: 1;">
                  {{ $t("punkstar.freespin.text2") }}
            <br />{{ $t("punkstar.freespin.text3") }}
            <br />{{ $t("punkstar.freespin.text4") }}
          </span>
           </div>
         
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_8.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`" style="line-height: 0.9;">
                  {{ "5 - " + paytable[8][4] }} 
            <br />{{ "4 - " + paytable[8][3] }}
            <br />{{ "3 - " + paytable[8][2] }}
            <br />{{ "2 - " + paytable[8][1] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_7.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`" >
                  {{ "5 - " + paytable[7][4] }} 
            <br />{{ "4 - " + paytable[7][3] }}
            <br />{{ "3 - " + paytable[7][2] }}
            <br />{{ "2 - " + paytable[7][1] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_6.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`" >
                  {{ "5 - " + paytable[6][4] }} 
            <br />{{ "4 - " + paytable[6][3] }}
            <br />{{ "3 - " + paytable[6][2] }}
            <br />{{ "2 - " + paytable[6][1] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_5.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`" >
                  {{ "5 - " + paytable[5][4] }} 
            <br />{{ "4 - " + paytable[5][3] }}
            <br />{{ "3 - " + paytable[5][2] }}
            <br />{{ "2 - " + paytable[5][1] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_4.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
                  {{ "5 - " + paytable[4][4] }} 
            <br />{{ "4 - " + paytable[4][3] }}
            <br />{{ "3 - " + paytable[4][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_3.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
                  {{ "5 - " + paytable[3][4] }} 
            <br />{{ "4 - " + paytable[3][3] }}
            <br />{{ "3 - " + paytable[3][2] }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_2.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
                  {{ "5 - " + paytable[2][4] }} 
            <br />{{ "4 - " + paytable[2][3] }}
            <br />{{ "3 - " + paytable[2][2] }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_1.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
                  {{ "5 - " + paytable[1][4] }} 
            <br />{{ "4 - " + paytable[1][3] }}
            <br />{{ "3 - " + paytable[1][2] }}
          </span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row ml-4">
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_0.png`)"
            alt=""
          />
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub symbol-line-height" :class="`-${lang}`">
                  {{ "5 - " + paytable[0][4] }} 
            <br />{{ "4 - " + paytable[0][3] }}
            <br />{{ "3 - " + paytable[0][2] }}
          </span>
        </div>
      </div>


      


      <div class="d-flex flex-column nav-punkstar mt-4">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang}`"
          >
            {{ $t("punkstar.bonus.title") }}
          </h5>
        </section>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row" style="margin-top:0.9rem">
        <div class="col-3 p-0 align-items-center d-flex">
          <img 
             class=" icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_11.png`)"
            alt=""
             style="width:80%"
          />
        </div>
        <div class="col-1 p-0 align-items-center d-flex">
        </div>
        <div class="col-8 p-0 align-items-center d-flex">
          <p class="m-0 text-sub symbol-line-height" :class="`-${lang}`">
          {{ $t("punkstar.bonus.text1") }} 
          <br />{{ $t("punkstar.bonus.text2") }} 
          <br /><u>{{ $t("punkstar.bonus.text3") }}</u><b><span style="font-size: larger;color: gold"> X525</span></b>
          </p>
        </div>
      </div>

    

      <div class="col-12 justify-content-center d-flex flex-row" >
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/paytable/punkstar/bonus3.png`)"
            alt=""
            style="width:80%"
          />
        </div>
         <div class="col-1 p-0 align-items-center d-flex"/>
           
         <div class="col-8 p-0 align-items-center d-flex">
           <p class="m-0 text-sub symbol-line-height" :class="`-${lang}`">
            {{ $t("punkstar.bonus.text4") }}
          </p>
         </div>
      </div>

      <div class="d-flex flex-column nav-punkstar mt-4">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang}`"
          >
            {{ $t("punkstar.freespin.title") }}
          </h5>
        </section>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row" >
        <div class="col-3 p-0 align-items-center d-flex">
          <img
            class="mt-3 icon-paytable"
            :src="require(`../../assets/resultGame/punkstar/symbol_10.png`)"
            alt=""
            style="width:80%"
          />
        </div>
         <div class="col-1 p-0 align-items-center d-flex"/>
           
         <div class="col-8 p-0 align-items-center d-flex">
           <p class="m-0 text-sub symbol-line-height" :class="`-${lang}`">
            {{ $t("punkstar.freespin.text1") }}
            <br/>{{ $t("punkstar.freespin.text5") }}
            <br/>{{ $t("punkstar.freespin.text6") }}
            <br/>{{ $t("punkstar.freespin.text7") }}
          </p>
         </div>
      </div>
   
      
       <div class="d-flex flex-column nav-punkstar mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
       <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/punkstar/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
       <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex ">
        <span class=" m-0 text-sub symbol-line-height" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-punkstar mt-4">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang}`"
          >
            {{ $t("punkstar.line.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub symbol-line-height" :class="`-${lang}`">
          {{ $t("punkstar.line.text1") }} <br />
          {{ $t("punkstar.line.text2") }} <br />
          {{ $t("punkstar.line.text3") }}
        </p>
      </div>
      <div class="justify-content-center d-flex flex-row">
        <img
          class="icon-paytable"
          :src="require(`../../assets/paytable/punkstar/pay_line.png`)"
          alt=""
        />
      </div>

      <div class="d-flex flex-column nav-punkstar mt-4">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang}`"
          >
            {{ $t("punkstar.winbetline.title") }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-3">
        <p class="m-0 text-sub symbol-line-height " :class="`-${lang}`">
          {{ $t("punkstar.winbetline.text1") }} <br />
          {{ $t("punkstar.winbetline.text2") }} <br />
          {{ $t("punkstar.winbetline.text3") }}
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-punkstar',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable,
    };
  },
};
</script>

<style>

.wild-positon {
	position: relative;
}

.nav-punkstar {
	background-color: #a11010;
	border-radius: 14px;
}

.icon-paytable {
	width: 100%;
}

.icon-paytable.-wild {
	position: absolute;
	width: 18%;
	height: 17.6vw;
}

.icon-paytable-punkstar {
	width: 65vw;
}

.bg-punkstar {
	background: #391818;
}

.icon-paytable-special {
  width: 82%;
}

.text-sub.-special {
  font-size: 4.5vw;
}

.nav-special-symbols {
  border-color: #1eaca6;
  border-style: solid;
  border-radius: 15px;
  border-width: thick;
}

@media screen and (max-width: 768px) {
	.bg-punkstar {
		background: #000;
	}
}
.text-freespin-punkstar {
	color: #ffe463;
	font-size: 4.5vw;
}

.nav-wild {
	border-radius: 0px 14px 14px 0px;
	border-left-style: solid;
	border-right-style: solid;
	border-top-style: solid;
	border-bottom-style: solid;
	border-color: #1eaca6;
	width: 100%;
	height: 24.5vw;
	margin-left: 17vw;
}

.icon-paytable.-wild {
	margin-right: 100px;
}

.hr-freespin-punkstar {
	border: 2px solid #ffe463;
	border-radius: 5px;
	margin-top: 0vw;
}

@media screen and (max-width: 768px) {
	.header > div {
		flex-grow: 0;
		width: 33.33%;
	}
}
.symbol-line-height{
  line-height: 1.1;
}
.pading4{
  padding: 4px;
}
</style>